module.exports = __webpack_public_path__ + "img/chair4.12d20a78.jpg";